import React, { useState } from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { filterComponents, PreDefinedFilterTypes } from './utility'

export function PreDefinedFilters({
  treeId,
  versionId,
  filters,
}: {
  treeId: string
  versionId: string
  filters: PreDefinedFilterTypes[]
}) {
  const [selectedFilter, setSelectedFilter] = useState<PreDefinedFilterTypes>(
    filters[0],
  )

  const SelectedFilter = () => {
    const Component = filterComponents[selectedFilter]
    if (!Component) return null
    return <Component treeId={treeId} versionId={versionId} />
  }

  return (
    <Box>
      <Box>
        <FormControl sx={{ m: 1, minWidth: 80 }}>
          <InputLabel id="pre-defined-filters-label">
            Pre Defined Filters
          </InputLabel>
          <Select<PreDefinedFilterTypes>
            labelId="pre-defined-filters-label"
            label="Pre Defined Filters"
            value={selectedFilter}
            autoWidth
            data-testid="PreDefinedFilterTypes"
            onChange={({ target: { value } }) =>
              setSelectedFilter(value as PreDefinedFilterTypes)
            }
          >
            {filters.map((filter) => {
              return (
                <MenuItem key={filter} value={filter}>
                  {filter}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Box>
      <Box padding="20px">
        <SelectedFilter />
      </Box>
    </Box>
  )
}
